import iconAddSelfie from 'url:../img/icons/menu-add-selfie.svg';
import iconHelp from 'url:../img/icons/menu-help.svg';
import iconQR from 'url:../img/icons/menu-show-qr.svg';
import { createLanguageSwitcher } from '../../../packages/src/localization/languageSwitcher.js';
import { pageRoutes } from './page-routes.js';
import { getCurrentLanguageSettings, t } from './localization.js';

export function updateQRMenuText(isShowMode = false) {
  const qrMenuItem = document.querySelector('#openQRreader .menu__item-text');
  if (qrMenuItem) {
    qrMenuItem.textContent = isShowMode ? t('menu-album-code') : t('menu-qr-scanner');
  }
}

export function initMenu() {
  const $menu = document.querySelector('.menu');
  const $menuList = document.querySelector('.menu__list');
  const $menuFooter = document.querySelector('.menu__footer');
  const $menuLanguageSwitcher = document.querySelector('.menu__language-switcher');
  const $btnOpen = document.querySelector('.top-panel__button-menu');
  const $btnClose = document.querySelector('.menu__btn-close');

  if (!$menu || !$menuList) {
    return;
  }

  const menuList = [
    {
      text: t('menu-registered-selfies'),
      icon: iconAddSelfie,
      isHidden: false,
      htmlId: 'selfies',
      href: pageRoutes.selfies,
    },
    {
      text: t('menu-qr-scanner'),
      icon: iconQR,
      isHidden: false,
      htmlId: 'openQRreader',
      htmlClass: 'qr-btn',
    },
    {
      text: t('menu-privacy'),
      icon: iconHelp,
      isHidden: true,
      htmlId: 'privacy-link',
      href: pageRoutes.privacyPolicy,
    },
    {
      text: t('menu-faq'),
      icon: iconHelp,
      isHidden: true,
      htmlId: 'faq-link',
      href: pageRoutes.faq,
    },
    {
      text: t('menu-support'),
      icon: iconHelp,
      isHidden: true,
      htmlClass: 'open-zendesk',
    },
  ];

  if ($btnOpen && $btnClose) {
    $btnOpen.addEventListener('click', () => {
      $menu.classList.remove('menu_hidden');
    });

    $btnClose.addEventListener('click', () => {
      $menu.classList.add('menu_hidden');
    });
  }

  const template = menuList.map(({ text, icon, isHidden, href, htmlId, htmlClass }) => {
    const classHidden = isHidden ? 'menu__item_hidden' : '';
    const customClass = htmlClass || '';
    const attrId = htmlId ? ` id="${htmlId}"` : '';
    const attrHref = href ? ` href="${href}"` : '';
    return `
      <a class="menu__item ${classHidden} ${customClass}"${attrId}${attrHref}>
        <img class="menu__item-icon" src="${icon}" alt="" />
        <div class="menu__item-text">${text}</div>
      </a>
    `;
  });

  $menuList.innerHTML = template.join('');

  if (!$menuFooter || !$menuLanguageSwitcher) {
    return;
  }

  const languageSettings = getCurrentLanguageSettings();
  if (languageSettings.availableLanguages.length <= 1) {
    $menuFooter.classList.add('menu__footer_hidden');
    $menuLanguageSwitcher.hidden = true;
    return;
  }

  $menuFooter.classList.remove('menu__footer_hidden');
  createLanguageSwitcher($menuLanguageSwitcher, languageSettings.availableLanguages);
}
